import { Controller } from '@hotwired/stimulus';

/** Generator explore rail: compact fixed sidebar after scroll on wide screens. */
export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 520 },
  };

  connect() {
    this.desktopQuery = window.matchMedia('(min-width: 1280px)');
    this.onScroll = this.onScroll.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    this.desktopQuery.addEventListener('change', this.onBreakpointChange);
    this.syncBreakpoint();
  }

  disconnect() {
    this.desktopQuery?.removeEventListener('change', this.onBreakpointChange);
    window.removeEventListener('scroll', this.onScroll);
  }

  syncBreakpoint() {
    window.removeEventListener('scroll', this.onScroll);

    if (!this.desktopQuery.matches) {
      this.hide();
      return;
    }

    if (this.shouldRevealImmediately()) {
      this.reveal();
      return;
    }

    if (this.revealed) return;

    this.showPending();
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  onBreakpointChange() {
    this.revealed = false;
    this.element.classList.remove('generator-explore-rail--revealed');
    this.syncBreakpoint();
  }

  hide() {
    this.element.classList.add('generator-explore-rail--pending');
    this.element.classList.remove('generator-explore-rail--revealed');
  }

  showPending() {
    this.element.classList.add('generator-explore-rail--pending');
    this.element.classList.remove('generator-explore-rail--revealed');
  }

  shouldRevealImmediately() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  onScroll() {
    if (window.scrollY >= this.thresholdValue) this.reveal();
  }

  reveal() {
    if (this.revealed) return;

    this.revealed = true;
    this.element.classList.remove('generator-explore-rail--pending');
    this.element.classList.add('generator-explore-rail--revealed');
    window.removeEventListener('scroll', this.onScroll);
  }
}
